// removed by extract-text-webpack-plugin
module.exports = {"review":"review__1ZC8R","user":"user__2_tsi","profile-photo":"profile-photo__3WgaH","content":"content__1pXq4","review-meta":"review-meta__3eJDw","meta-user":"meta-user__3UQrN","body":"body__3SuE-"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/BaseReview/Review/styles.scss
// module id = ./app/scripts/views/App/components/BaseReview/Review/styles.scss
// module chunks = 1